import { render, staticRenderFns } from "./CreateDataSystem.vue?vue&type=template&id=36ff9ff7&scoped=true"
import script from "./CreateDataSystem.vue?vue&type=script&lang=js"
export * from "./CreateDataSystem.vue?vue&type=script&lang=js"
import style0 from "./CreateDataSystem.vue?vue&type=style&index=0&id=36ff9ff7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff9ff7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ff9ff7')) {
      api.createRecord('36ff9ff7', component.options)
    } else {
      api.reload('36ff9ff7', component.options)
    }
    module.hot.accept("./CreateDataSystem.vue?vue&type=template&id=36ff9ff7&scoped=true", function () {
      api.rerender('36ff9ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/CreateDataSystem.vue"
export default component.exports